// extracted by mini-css-extract-plugin
export var swipeContainer = "f6Rb8";
export var swipeIcon = "QkerH";
export var swipeIconFull = "jFHYY";
export var swipeLeft = "gR7_v";
export var swipeRight = "qUrge";